"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const validators_1 = require("../../validators");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const EmailTemplate_1 = require("./EmailTemplate");
const EmailTemplateBlock_1 = require("./EmailTemplateBlock");
const EmailTemplateVersionDeployment_1 = require("./EmailTemplateVersionDeployment");
const HostedFile_1 = require("../core/HostedFile");
const auth_1 = require("../auth");
let EmailTemplateVersion = class EmailTemplateVersion extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User, { nullable: true }),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersion.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column(),
    class_validator_1.Validate(validators_1.IsSemVer),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersion.prototype, "version", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersion.prototype, "originalHTML", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersion.prototype, "html", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersion.prototype, "releaseNotes", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailTemplate_1.EmailTemplate),
    typeorm_1.ManyToOne(() => EmailTemplate_1.EmailTemplate, template => template.versions),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersion.prototype, "template", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.template),
    tslib_1.__metadata("design:type", Number)
], EmailTemplateVersion.prototype, "templateId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => HostedFile_1.HostedFile, { nullable: true }),
    typeorm_1.ManyToOne(() => HostedFile_1.HostedFile),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersion.prototype, "screenshot", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    class_validator_1.IsUrl(),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersion.prototype, "url", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: 'templateURL' }),
    class_validator_1.IsIn([
        'templateURL',
        'versionURL',
        'pastedHTML',
        'hostedFileURL',
        'oceanEditor',
        'emailEditor',
    ]),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersion.prototype, "codePulledFrom", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailTemplateVersionDeployment_1.EmailTemplateVersionDeployment]),
    typeorm_1.OneToMany(() => EmailTemplateVersionDeployment_1.EmailTemplateVersionDeployment, deployment => deployment.version),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersion.prototype, "deployments", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailTemplateBlock_1.EmailTemplateBlock]),
    typeorm_1.ManyToMany(() => EmailTemplateBlock_1.EmailTemplateBlock, block => block.versions),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersion.prototype, "blocks", void 0);
EmailTemplateVersion = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], EmailTemplateVersion);
exports.EmailTemplateVersion = EmailTemplateVersion;
class EmailTemplateVersionEntity extends EmailTemplateVersion {
    toString() {
        return this.version || `Email template version #${this.id}`;
    }
    toEndpoint() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const t = yield this.template;
            if (!t) {
                return `/templates?failed=${encodeURI('No template found')}`;
            }
            return `/templates/${t.id}/versions/${this.version}`;
        });
    }
}
exports.EmailTemplateVersionEntity = EmailTemplateVersionEntity;
//# sourceMappingURL=EmailTemplateVersion.js.map